import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

import { CalendarDayInfo } from './types';
import CalendarDayColor from './CalendarDayColor.vue';

@Component({
    components: { 
        CalendarDayColor
    },
})
export default class CalendarDay extends Vue {
  @Prop({ type: Object }) item!: CalendarDayInfo;

  get colors() {
    return this.item.colors.slice(0, 1);
  }

  get classNames() {
    const { selected, isToday, isOut, isSun, isSat } = this.item;
    return {
      selected: selected,
      today: isToday,
      'prev-month': isOut,
      week: isSun || isSat,
    };
  }
}
